module.exports = "/_next/static/images/SingleSourceOfTruth@2x-4f167587274a67c01a78c30ae760c8f3.png";